var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightFit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 15461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 15433"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55",
    cx: 11.1111,
    cy: 38.8885,
    r: 10.8333,
    stroke: "#FF2D20",
    strokeWidth: 0.555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56",
    cx: 36.1111,
    cy: 11.1111,
    r: 10.8333,
    stroke: "#0000FF",
    strokeWidth: 0.555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57",
    cx: 22.2223,
    cy: 25.0001,
    r: 19.4444,
    fill: "#FD5901"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58",
    cx: 2.77778,
    cy: 5.55512,
    r: 2.77778,
    fill: "#FD5901",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 59",
    cx: 46.6667,
    cy: 38.8891,
    r: 2.77778,
    fill: "#FD5901",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6713 26.7619H18.4582C18.4675 26.7612 18.4747 26.7566 18.484 26.7566C18.7568 26.7566 18.9783 26.9781 18.9783 27.2509C18.9783 27.2523 18.9783 27.2536 18.9783 27.2549C18.9783 27.9826 19.5682 28.5731 20.2966 28.5731C21.0249 28.5731 21.6148 27.9832 21.6148 27.2549C21.6148 27.2536 21.6148 27.2523 21.6148 27.2503C21.6148 26.9774 21.8363 26.7559 22.1092 26.7559C22.1184 26.7559 22.1257 26.7606 22.1349 26.7612H23.4248V25.8846C22.3807 25.6513 21.6122 24.7325 21.6122 23.6337C21.6122 22.535 22.3807 21.6169 23.4097 21.3862L23.4248 21.3835V20.0027C23.4248 19.7298 23.6463 19.5084 23.9192 19.5084H31.169C31.4419 19.5084 31.6633 19.7298 31.6633 20.0027V27.2371L31.6666 27.2529V34.5031C31.6666 34.776 31.4452 34.9975 31.1723 34.9975L16.672 35.0001C16.3991 35.0001 16.1776 34.7787 16.1776 34.5058V27.2556C16.1776 26.9827 16.3991 26.7612 16.672 26.7612L16.6713 26.7619ZM30.674 20.4977H24.4129V21.8225C24.4129 22.0954 24.1914 22.3168 23.9185 22.3168C23.1902 22.3168 22.6002 22.9067 22.6002 23.6351C22.6002 24.3634 23.1902 24.9533 23.9185 24.9533C24.1914 24.9533 24.4129 25.1747 24.4129 25.4476V26.7592H25.2902C25.5215 25.7126 26.441 24.9414 27.5411 24.9414C28.6412 24.9414 29.5607 25.7126 29.7894 26.7434L29.792 26.7586H30.674V20.4977ZM30.6773 27.7479H29.3873C29.3761 27.7486 29.3669 27.7545 29.3557 27.7545C29.0815 27.7505 28.8607 27.5284 28.8587 27.2542C28.8567 26.5286 28.2681 25.9406 27.5418 25.9406C26.8147 25.9406 26.2248 26.5299 26.2248 27.2575C26.2248 27.2588 26.2248 27.2595 26.2248 27.2608C26.2248 27.5337 26.0033 27.7552 25.7305 27.7552C25.7193 27.7552 25.71 27.7492 25.6988 27.7486H24.4148V28.6265C25.4589 28.8605 26.2275 29.7799 26.2275 30.878C26.2275 31.8285 25.652 32.6451 24.8301 32.9971L24.8149 33.003C24.7022 33.0518 24.5684 33.0946 24.43 33.1256L24.4148 33.1282V34.0101H30.6766L30.6773 27.7479ZM17.1657 34.0121H23.4268V32.7202C23.4261 32.7104 23.4209 32.7018 23.4209 32.6919C23.4248 32.4177 23.6469 32.1969 23.9205 32.1949C24.6469 32.193 25.2348 31.6044 25.2348 30.878C25.2348 30.1504 24.6449 29.5611 23.9178 29.5611C23.9165 29.5611 23.9159 29.5611 23.9146 29.5611C23.6417 29.5611 23.4202 29.3397 23.4202 29.0668C23.4202 29.0569 23.4255 29.0483 23.4261 29.0384V27.7512H22.5442C22.3089 28.7926 21.3914 29.5585 20.2952 29.5585C19.1991 29.5585 18.2816 28.7926 18.0496 27.7664L18.0469 27.7512H17.165L17.1657 34.0121ZM12.7165 15.5557H19.9657C20.2386 15.5557 20.46 15.7771 20.46 16.05V17.8309C20.4607 17.8421 20.4666 17.8513 20.4666 17.8626C20.4666 18.1354 20.2452 18.3569 19.9723 18.3569C19.2439 18.3569 18.654 18.9468 18.654 19.6751C18.654 20.4034 19.2439 20.9933 19.9723 20.9933C20.2452 20.9933 20.4666 21.2148 20.4666 21.4877C20.4666 21.4989 20.4607 21.5081 20.46 21.5193V23.3002C20.46 23.5731 20.2386 23.7946 19.9657 23.7946H18.5973C18.364 24.8386 17.4452 25.6071 16.3464 25.6071C15.2476 25.6071 14.3294 24.8386 14.0987 23.8097L14.0961 23.7946H12.7165C12.4436 23.7946 12.2222 23.5731 12.2222 23.3002V16.05C12.2222 15.7771 12.4436 15.5557 12.7165 15.5557ZM13.2109 22.8059H14.5344C14.8073 22.8059 15.0288 23.0274 15.0288 23.3002C15.0288 24.0285 15.6187 24.6184 16.347 24.6184C17.0754 24.6184 17.6653 24.0285 17.6653 23.3002C17.6653 23.0274 17.8868 22.8059 18.1597 22.8059H19.4713V21.924C18.4306 21.688 17.6653 20.7712 17.6653 19.6751C17.6653 18.579 18.4306 17.6622 19.4562 17.4295L19.4713 17.4269V16.545H13.2109V22.8059Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightFit);
export default __webpack_public_path__ + "static/media/RightFit.55da4788f9de5ff067e0d43026544870.svg";
export { ForwardRef as ReactComponent };